import { motion } from "framer-motion";

import Instagram from '../../assets/img/footer/f_instagram.png'
import Facebook from '../../assets/img/footer/f_facebook.png'
import WhatsApp from '../../assets/img/footer/f_whatsapp.png'
import Youtube from '../../assets/img/footer/f_youtube.png'
import logo from '../../assets/img/footer/f_Logo.png'


import "./footer.css"



function Footer() {
    return (
        <div className="footer">
            <div>
                <motion.img
                    src={logo}
                    alt="Logo"
                    className=""
                    initial={{ x: 0, y: 0 }}


                />
            </div>
            <div>
                <h1>Fale conosco</h1>
                <p> 11 976391355</p>
                <p>E-mail: ripafactory@institutoripaxote.org.br</p>
            </div>
            <div>
                <h1 className="social">Social</h1>
                <div>

                    <a href="https://api.whatsapp.com/send?phone=5511966131854" target="_blank" rel="noopener noreferrer">
                        <img src={WhatsApp} alt="WhatsApp Icone" />
                    </a>
                    <a href="https://www.facebook.com/ripaxoteOFICIAL" target="_blank" rel="noopener noreferrer">
                        <img src={Facebook} alt="Facebook Icone" />
                    </a>
                    <a href="https://www.youtube.com/@ripaxote" target="_blank" rel="noopener noreferrer">
                        <img src={Youtube} alt="YouTube Icone" />
                    </a>
                    <a href="https://www.instagram.com/ripafactory/" target="_blank" rel="noopener noreferrer">
                        <img src={Instagram} alt="Instagram Icone" />
                    </a>
                   
                </div>
            </div>
        </div>
    );
}

export default Footer;